export interface ExtensionConfig {
    appUrl: string;
    context: ExtensionContext;
    isStaticPatch: boolean;
    routingPatched: boolean;
    serverId: string;
    serverUrl: string;
    serverVersion: string;
    licenseFlags: string[];
}
export enum ExtensionContext {
    vizportal = 'vizportal',
    vizql = 'vizql'
}